import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFolder = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--folder")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M8.46481624,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,19 C3,19.5522847 3.44771525,20 4,20 L20,20 C20.5522847,20 21,19.5522847 21,19 L21,8 C21,7.44771525 20.5522847,7 20,7 L11,7 C10.6656468,7 10.3534155,6.83289886 10.1679497,6.5547002 L8.46481624,4 Z M11.5351838,5 L20,5 C21.6568542,5 23,6.34314575 23,8 L23,19 C23,20.6568542 21.6568542,22 20,22 L4,22 C2.34314575,22 1,20.6568542 1,19 L1,5 C1,3.34314575 2.34314575,2 4,2 L9,2 C9.33435319,2 9.64658452,2.16710114 9.83205029,2.4452998 L11.5351838,5 Z" id="icon--centivo--folder"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-468.000000, -636.000000)"/>
          <g id="Icon/folder">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--folder"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--folder"/>
          </g>
      </g>
  </IconWrapper>
)
